'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuickLinks = function (_Component) {
  (0, _inherits3.default)(QuickLinks, _Component);

  function QuickLinks(props) {
    (0, _classCallCheck3.default)(this, QuickLinks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuickLinks.__proto__ || (0, _getPrototypeOf2.default)(QuickLinks)).call(this, props));

    _this.state = {
      hasBeenOpened: false,
      showMenu: false
    };
    return _this;
  }

  (0, _createClass3.default)(QuickLinks, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.hideMenu.bind(this), true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.hideMenu.bind(this), true);
    }
  }, {
    key: 'hideMenu',
    value: function hideMenu(event) {
      if (this.state.showMenu) {
        event.stopPropagation();
        this.setState({ showMenu: false });
      }
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu() {
      this.setState({
        hasBeenOpened: true,
        showMenu: !this.state.showMenu
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var menuState = this.state.showMenu ? 'open' : 'closed';

      return _react2.default.createElement(
        'div',
        { className: 'QuickLinks ' + (this.state.hasBeenOpened ? menuState : '') },
        _react2.default.createElement(_caligramReact.Button, { action: this.toggleMenu.bind(this), title: 'Liens rapides de l\u2019UQAM', iconLeft: this.state.showMenu ? 'minus' : 'plus', hideTitle: true, type: 'primary' }),
        _react2.default.createElement(
          'div',
          { className: 'menu' },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://www.uqam.ca/' },
                'Page d\'accueil de l\'UQAM'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://www.etudier.uqam.ca/' },
                '\xC9tudier \xE0 l\'UQAM'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://www.repertoire.uqam.ca' },
                'Bottin du personnel'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://www.uqam.ca/campus' },
                'Carte du campus'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://www.bibliotheques.uqam.ca/' },
                'Biblioth\xE8ques'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://www.uqam.ca/joindre' },
                'Pour nous joindre'
              )
            )
          )
        )
      );
    }
  }]);
  return QuickLinks;
}(_react.Component);

exports.default = QuickLinks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickLinks.js
// module id = 1121
// module chunks = 0